<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table th>.cell {
    white-space: pre-wrap;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;" >
    <template>
      <div class="content_body">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item style="padding-top: 8px;">企业申报</el-breadcrumb-item>
          <el-breadcrumb-item style="padding-top: 8px;">填报评价指标</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider content-position="left"></el-divider>
      </div>
      <el-tabs v-model="active" type="card" @tab-click="handleClick">
        <el-tab-pane name="declare">
          <template #label>
            <span><i class="el-icon-date"></i> 药品综合评价</span>
            <!-- <el-badge :value="declareResult.goodsNum" class="item"></el-badge> -->
          </template>
          <el-alert :closable="false" title="提示：" type="primary" show-icon style="margin-bottom: 15px; width: 980px;">
            <p style="font-size: 13px; font-weight: 400; line-height: 24px;">&emsp;1、申报企业在申报截止时间前，按要求完成报名药品综合评价相关数据填报并提交确认（先报名再评价）。 </p>
            <p style="font-size: 13px; font-weight: 400; line-height: 24px;">&emsp;2、<b>企业须对申报数据的真实性、完整性负责。</b>申报企业如存在虚假申报情况，将取消申报和中选资格，并纳入不诚信名单予以公布。</p>
            <p style="font-size: 13px; font-weight: 400; line-height: 24px;">&emsp;3、在申报截止时间前，企业可对已填报信息进行检查核对，如有调整须及时更新。
在申报截止时间后，企业填报的药品综合评价相关数据将向同一分组内所有企业公示，公示期间接受企业申诉或澄清，并根据处理情况进行计分修正，修正结果实时公示。</p>
<p style="font-size: 13px; font-weight: 400; line-height: 24px;">&emsp;4、如被确认为中选企业，在中选后指定时间内，提供与所填报药品综合评价数据一致的资质证明材料（同一企业多个药品，企业维度有关的证明材料可只提供一份）。</p>

          </el-alert>
          <!-- <el-alert :closable="false" title="工作提示：" type="info" show-icon style="margin-bottom: 15px; width: 980px;">
            <p>&emsp;材料申报所含三项内容（药品综合评价、价格填报、历史履约情况调查表）应在申报截止日期（7月13日）前完成。</p>
          </el-alert> -->
          <el-table :data="queryform.data" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys" ref="tableRef">
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
            <!-- <el-table-column prop="drugTypeFlagZx" label="分类" width="65" align='center'></el-table-column> -->
            <el-table-column prop="drugName" label="通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="drugDosage" label="剂型" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="packageSpecific" label="包装规格" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="producerName" label="生产企业" width="160" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="code" label="药品统一编码" width="135" align='center'></el-table-column>
            <el-table-column fixed="right" prop="score" label="综合评价分" width="65" align='right'></el-table-column>
            <el-table-column fixed="right" prop="statusDesc" label="星级" width="65" align='right'></el-table-column>
            <!-- <el-table-column fixed="right" prop="offer" label="报价" width="80" align='center'>
              <template scope="scope">
                <el-input size="mini" v-model="scope.row.offer" placeholder="请输入报价" @change="checkOffer(scope.row)"></el-input>
              </template>
            </el-table-column> -->
            <el-table-column fixed="right" label="操作" width="120" align='center'>
              <template #default="scope">
                <el-button @click="operate = true; handleClick(scope.row, scope.row.fn)" :type="scope.row.btnType" v-if="scope.row.fn" size="mini" plain>{{scope.row.operate}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="(val) => handlePagination(null, val, 'queryform')" @current-change="(val) => handlePagination(val, null, 'queryform')" @prev-click="(val) => handlePagination(val, null, 'queryform')" @next-click="(val) => handlePagination(val, null, 'queryform')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="queryform.pageNo"
            :page-sizes="queryform.pageSizes" :page-size="queryform.pageSize" :total="queryform.total">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>

  <!-- 生产企业药品药品综合评价（西药 -> 自评） -->
  <el-dialog :title="product.drugInfo" :visible.sync="dialogFormVisible" width="1280px" top="0px" marginTop="5px" marginButton="5px" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <el-form key="product" :model="product" :rules="productRules" ref="product" label-width="200px">
      <el-collapse v-model="activeName">
        <el-collapse-item v-for="(outer, key) in xnItems" v-if="outer.name" :key="key" :disabled="outer.disabled" :name="key">
          <template #title>
            <h4 style="width: 220px; text-align: right;">
              {{outer.name}}（{{outer.score}}分）
              <template v-if="outer.val">
                <el-badge type="primary" :value="outer.val" v-if="outer.val" :max="200" class="sub-assess-score"></el-badge>
              </template>
              <template v-else>
                <div class="el-badge sub-assess-score" style="width: 27px;"></div>
              </template>
            </h4>
            &emsp;&emsp;<el-alert v-if="outer.info" :title="outer.info" type="info" show-icon :closable="false"></el-alert>
          </template>
          <div v-for="inner in outer.subItems" style="border-bottom: 1px dashed #c0c0c0; margin-bottom: 5px; padding: 3px 0;">
            <el-form-item label-position="top" label-width="210px">
              <template #label>
                <template v-if="inner.remark">
                  <el-tooltip placement="right" effect="light">
                    <div slot="content" v-html="inner.remark" style="color: #999; font-size: 14px;line-height: 24px; width: 450px;"></div>
                    <el-tag type="warning" effect="plain">{{inner.name}}<i class="el-icon-info" style="font-size: 16px;"></i></el-tag>
                  </el-tooltip>
                </template>
                <template v-else>
                  <el-tag effect="plain">{{inner.name}}</el-tag>
                </template>
              </template>
              <template v-if="`el-radio-group` === inner.type">
                <el-radio-group size="mini" v-model="product[`${key}${inner.index}`]">
                  <div v-for="w in xnConfigMap.get(`${key}${inner.index}`)" :class="w.htmlClass">
                    <el-radio border :label="w.id" :disabled="0 == w.scode" @click.native.prevent="handleRadioClick(w, `${key}${inner.index}`, inner)">
                      {{w.remark}}{{0 == w.scode ? '' : '（' + w.svalue + '分）'}}
                    </el-radio>
                  </div>
                </el-radio-group>
              </template>
              <template v-if="`el-checkbox-group` === inner.type">
                <el-checkbox-group size="mini" v-model="product[`${key}${inner.index}`]">
                  <div v-for="w in xnConfigMap.get(`${key}${inner.index}`)" :class="w.htmlClass">
                    <el-checkbox border :label="w.id" :disabled="0 == w.scode" @click.native.prevent="handleCheckboxClick(w, `${key}${inner.index}`, inner)">
                      {{w.remark}}{{0 == w.scode ? '' : '（' + w.svalue + '分）'}}
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </template>
            </el-form-item>
          </div>
        </el-collapse-item>
        <el-tag type="danger" effect="plain" style="font-size: 14px; text-align: left; width: 100%;">&emsp;&emsp;提示：企业须对申报数据的真实性、完整性负责。如存在虚假申报情况，将取消申报和中选资格，并纳入不诚信名单予以公布。</el-tag>
        <!-- <el-collapse-item disabled>
          <template #title>
            <el-tag type="info" effect="plain">备注/说明</el-tag>
            <el-input type="textarea" rows="1" placeholder="请输入备注/说明" v-model="product.remark" maxlength="200" show-word-limit style="width: 85%"></el-input>
          </template>
        </el-collapse-item> -->
      </el-collapse>
    </el-form>
    <template #footer>
      <span>
        <!-- <el-button size="mini" @click="operator = -1; getByAssess()"><i class="el-icon-d-arrow-left"></i>&nbsp;上一个</el-button> -->
        <el-button size="mini" @click="closeDialogForm">关&emsp;闭</el-button>
        <el-button size="mini" @click="activeName=[]">折叠所有</el-button>
        <el-badge type="success" :value="product.score" :max="200" class="assess-score">
          <el-button size="mini" :loading="submitButtonLoading" type="primary" @click="submitForm('product')">提&emsp;交</el-button>
        </el-badge>
        <!-- <el-button size="mini" @click="operator = 1; getByAssess()">下一个&nbsp;<i class="el-icon-d-arrow-right"></i></el-button> -->
      </span>
    </template>
  </el-dialog>
  <template slot="xn-slot" slot-scope="{ data }">
    {{xnItems[data].remark}}
  </template>

  <FooterView></FooterView>
</div>

</template>
<script>
  export default {
    name: 'mydeclare',
    data(){
      var validateValid = (rule, value, callback) => {
        if(0 > Number(value)) {
          callback(new Error('请输入大于0的数字（两位小数）'));
        }else{
          callback();
        }
      };
      var validateRate = (rule, value, callback) => {
        if(0 >= Number(value)){
          callback(new Error('还款比例应大于0'));
        }else{
          callback();
        }
      };

      return {
        active: 'declare',
        height: 0,
        operate: false,
        operator: 0,
        changed: '',
        blackInputVisible: true,
        submitButtonLoading: false,
        dialogPasswordVisible: false,
        btnActive: [true, false, false, false, false, false, false, false],
        activeName: [],
        tabPosition: 'left',
        declareResult: null,
        captchaUrl: '',
        uploadImgUrl: '',
        offerUploadUrl: '',
        fileListOfferFile: [],
        fileListfddbrsqzsImg:[],
        //审核直接可以质量评级、在线报价 原 bargainform.status: 5
        bargainform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getProductPage', status: 2
        },
        bargainOnlineForm: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getBargainOnlinePage', stype: 'OFFERONLINE'
        },
        formRules: {
          payableSum: [
            { required: true, message: '请输入应付款金额', trigger: 'blur' },
            { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/, message: '请输入大于0的数字（两位小数）', trigger: 'blur'},
            { validator: validateValid, trigger: 'blur', message: '请输入大于0的数字（两位小数）' },
          ],
          paymentSum: [
            { required: true, message: '请输入已付款金额', trigger: 'blur' },
            { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/, message: '请输入大于0的数字（两位小数）', trigger: 'blur'},
            { validator: validateValid, trigger: 'blur', message: '请输入大于0的数字（两位小数）' },
          ],
          decemberRate: [
            { pattern: /^\d+\.?\d{0,2}$/, message: '请输入大于0的数字（两位小数）', trigger: 'blur'},
            { validator: validateRate, trigger: 'blur', message: '请输入大于0的数字（两位小数）' },
          ],
          surplusWay: [
            { required: true, message: '请输入尾款处置计划', trigger: 'blur' },
          ],
        },
        xnItems: {
          'xn11': { id: '', val: 0, name: '药品可及性', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 40, disabled: false,
            subItems: [{type: 'el-radio-group', name: '基本药物目录（20分）', index: 1}, {type: 'el-radio-group', name: '医保目录（20分）', index: 2}],
            remark: '无补充说明！'},
          'xn12': { id: '', val: 0, name: '技术含量', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 30, disabled: false,
            subItems: [{type: 'el-radio-group', name: '基础分（25分）', index: 1}, {type: 'el-radio-group', name: '附加分（5分）', index: 2}],
            remark: ''},
          'xn13': { id: '', val: 0, name: '临床适用性', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 20, disabled: false,
            subItems: [{type: 'el-radio-group', name: '有效性（6分）', index: 1},
            {type: 'el-checkbox-group', name: '安全性（6分）', index: 2, remark: '安全性评价可多选，按勾选累计得分'},
            {type: 'el-radio-group', name: '经济性（8分）', index: 3}],
            remark: ''},
          'xn14': { id: '', val: 0, name: '产品市场占有情况', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 10, disabled: false,
            subItems: [{type: 'el-radio-group', name: '执行中的其他省级招标中标情况（3分）', index: 1}, {type: 'el-radio-group', name: '上一年度品种产量（4分）', index: 2}, {type: 'el-radio-group', name: '同品种全国市场占有率（3分）', index: 3}],
            remark: '无补充说明！'},
          'xn15': { id: '', val: 0, name: '企业质量管理水平', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 35, disabled: false,
            subItems: [{type: 'el-radio-group', name: '基础分（30分）', index: 1}, {type: 'el-radio-group', name: '附加分（5分）', index: 2}],
            remark: '无补充说明！'},
          'xn16': { id: '', val: 0, name: '企业药品保障供应能力', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 30, disabled: false,
            subItems: [{type: 'el-radio-group', name: '行业排名（15分）', index: 1,
            remark: '1、外资企业<br> 1.1、纳入美国《制药经理人》（Pharmaceutical Executive）上一年度排名前50强在大陆的独资或控股企业。（15分）<br//>1.2、未收录或排名超出50位（5分）<br/>2、内资企业<br/>	按最新出版《中国医药统计年报》中医药工业企业法人单位主营业务排名分5档计分。 <br/>2.1、前50强（15分）<br/>2.2、前100强（12分）<br/>2.3、前150强（8分）<br/>2.4、前200（4分）<br/>	2.5、未收录或排名超出200位（2分）'
            },
            {type: 'el-radio-group', name: '本市药品配送到位情况（15分）', index: 2}],
            remark: '无补充说明！'},
          'xn17': { id: '', val: 0, name: '企业创新能力', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 20, disabled: false,
            subItems: [{type: 'el-radio-group', name: '技术奖获奖情况（5分）', index: 1, remark: '1、外资企业<br/>&emsp;近3年内获Prix Galien奖（限英、法、德、美4国，每项1分，可累计，最高5分）<br/>2、内资企业<br/>&emsp;近3年内获国家级科学技术奖（二等及以上）（每项1分，可累计，最高5分）'},
            {type: 'el-radio-group', name: '省级以上企业技术中心(创新平台)认定情况（5分）', index: 2}, {type: 'el-radio-group', name: '上一年度新药注册申请量（5分）', index: 3}, {type: 'el-radio-group', name: '承担国家重大新药创制科技重大专项课题（5分）', index: 4}],
            remark: '无补充说明！'},
          'xn18': { id: '', val: 0, name: '企业社会责任承担', info: '同一产品按就高原则取一项得分（点我展开/折叠）', score: 15, disabled: false,
            subItems: [{type: 'el-checkbox-group', name: '多选项（15分）', index: 1, remark: '可多选，按勾选累计得分', repel: 'xn182'},
            {type: 'el-radio-group', name: '单选项（2分）', index: 2, repel: 'xn181'}],
            remark: '无补充说明！'},
          'xn19': { id: '', val: 0, name: '企业信誉度', info: '满足任意一项即扣分，最多扣减40分（点我展开/折叠）', score: -40, disabled: false,
            subItems: [{type: 'el-radio-group', name: '药品质量抽验通报', index: 1, remark: '每抽检(或不合格或召回)出一次，扣5分，最多扣40分（企业信誉度分值扣完为止）'},
                      {type: 'el-radio-group', name: '其他不良记录', index: 2, remark: '每出现一次扣10分，最多扣40分（企业信誉度分值扣完为止）'}],
            remark: '无补充说明！'},
          'XN': { id: '', val: 0, score: 0, disabled: false},
        },
        product: {
          productId: '', drugInfo: '', code: '', score: 0, blackRecord: '', blackMark: '', remark: '', stype: '',
          xn111: '', xn112: '', xn121: '',  xn122: '',
          xn131: '', xn132: [], xn133: '',
          xn141: '', xn142: '', xn143: '',
          xn151: '', xn152: '', xn161: '', xn162: '',
          xn171: '', xn172: '', xn173: '', xn174: '',
          xn181: [], xn182: '', xn191: '', xn192: '',
        },
        configList: [],
        xnConfigMap: new Map(),
        requiredMap: new Map(),
        selectedMap: new Map(),
        //不用审核直接可以质量评级、在线报价 queryform.status: 3
        queryform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50, 100], fn: 'getProductOfferPage', status: 2,
        },
        offerform: {
          id: '', attachsName: '', attachsPath: '', disabled: false,
        },
        dialogFormVisible: false,
        productRules: {},
        options: [],
        productOfferList: [],
      };
    },
    mounted(){
      //sessionStorage['/mydeclare'] = true;
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight -350}
    },
    created() {
      this.initView();
      this.captchaUrl = this.getCaptchaUrl();
      this.uploadImgUrl = process.env.VUE_APP_API_URL + 'member/o_upload_image2.jspx';
      this.offerUploadUrl = process.env.VUE_APP_API_URL + 'member/o_upload_offer.jspx';
    },
    watch:{
      declareResult: {
        handler(obj){
          //初始赋值
          this.btnActive[3] = false;
          if(obj && obj.expiryDate.time > +new Date()){
            if(0 < obj.goodsNum){
              this.btnActive[3] = true; //选择品种
            }
          }
        },
        deep:true, //true 深度监听
        immediate: true, //初次赋值也监听
      },
      'product.blackMark': {
        handler(data){
          if('XN' === this.product.stype){
            this.xnItems[this.product.stype].val = data ? -30 : 0;
          }else if('ZN' === this.product.stype){
            this.znItems[this.product.stype].val = data ? -30 : 0;
          }
        }
      }
    },
    methods: {
      selectable(d){
        return !d.checked;
      },
      thousandth(row, column, cellValue, index){
        if(cellValue && !isNaN(cellValue)){
          let str = new String(cellValue).split('.');
          let re = /\d{1,3}(?=(\d{3})+$)/g;
          let n1 = str[0].replace(re, "$&,");
          return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
        };
      },
      digit: function(num, length){
        var str = '';
        num = String(num);
        length = length || 2;
        for(var i = num.length; i < length; i++){
          str += '0';
        }
        return num < Math.pow(10, length) ? str + (num|0) : num;
      },
      toDateString: function(time, format){
        let date = new Date(time || new Date())
        ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
      },
      changCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      xnSlot(key){
        //console.info(key);
        return this.xnItems[key].remark;
      },
      initView(){
        setTimeout(() => {
          const self = this
          self.submitButtonLoading = true;
          //报名规则
          self.getDeclareResult({ stype: 'DECLARE' }).then(res => {
            self.handleDeclareResult(res, 'DECLARE')
            return self.getDeclareResult({stype: 'OFFER'})
          }).then(res => {
            //报价规则
            self.handleDeclareResult(res, 'OFFER')
            //药品综合评价规则，按化学药和中成药进行分组设置（map）
            return self.getBusinessConfig({ stype: 'XN' });
          }).then(res => {
            self.handleBusinessConfigList(res);
            let { status, pageNo, pageSize } = this.queryform;
            return self.productOfferPage({ status, pageNo, pageSize })
          }).then(res => {
            //已报名品种（药品综合评价）
            self.handleProductOfferPage(res);
            //不用审核直接可以质量评级、在线报价
            //return self.productPage({ status: 5, pageNo: 1, pageSize: 1000 })
            return self.productPage({ status: 2, pageNo: 1, pageSize: 1000 })
          }).then(res => {
            //报价品种
            self.handleProductPage(res)
          }).catch(err => {
            console.info(err);
          })
        })
      },
      handleClick(tab, event){
        if(this[event]){
          this[event].call(this, tab);
        }
      },
      handleRadioClick(w, subKey, config){
        const itemId = this.product[subKey];
        if(!itemId){
          this.product[subKey] = w.id;
          this.selectedMap.set(subKey, Number(w.svalue))
        }else if(itemId && w.id != itemId){
          this.product[subKey] =  w.id;
          this.selectedMap.set(subKey, Number(w.svalue))
        }else{
          if(!this.requiredMap.has(subKey)){
            this.product[subKey] = '';
            this.selectedMap.delete(subKey);
          }
        }
        //互斥字段，目前单选互斥的是多选
        if(config.repel){
          this.product[config.repel] = []
          this.selectedMap.delete(config.repel);
        }
        this.sumQualityScore();
      },
      handleCheckboxClick(w, subKey, config){
        const index = this.product[subKey].indexOf(w.id);
        let score = this.selectedMap.get(subKey) || 0;
        if(-1 === index){
          this.product[subKey].push(w.id);
          score += Number(w.svalue);
        }else{
          this.product[subKey].splice(index, 1);
          this.selectedMap.set(subKey, Number(w.svalue));
          score -= Number(w.svalue);
        }
        //互斥字段，目前单选互斥的是多选
        if(config.repel){
          this.product[config.repel] = ''
          this.selectedMap.delete(config.repel);
        }
        this.selectedMap.set(subKey, score);
        this.sumQualityScore();
      },
      sumQualityScore(){
        // const array = [],
        const groupMap = new Map();
        for(let elem of this.selectedMap.entries()){
          // array.push(elem[1]);
          let key = elem[0].slice(0, elem[0].length - 1);
          if(groupMap.has(key)){
            let score = groupMap.get(key) + Number(elem[1]);
            score = Math.abs(this.xnItems[key]['score']) > Math.abs(score) ? score : this.xnItems[key]['score'];
            groupMap.set(key, score);
          }else{
            groupMap.set(key, Number(elem[1]));
          }
        }
        for(let k in this.xnItems){
          if(groupMap.has(k)){
            this.xnItems[k].val = groupMap.get(k)
          }else{
            this.xnItems[k].val = 0;
          }
        }
        this.product.score = groupMap.values().reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0);
        return;
      },
      submitDiscount(d) {
        // d.visible = false;
        //提示用户是否保存
        const id = d.id;
        const userId = d.userId;
        const productId = d.productId;
        let privatePrice = d.privatePrice || '', declarePrice = d.declarePrice || '';
        // if(!discount || !declarePrice){
        //   this.$message({ message: '请先完成价格降幅和议价价格的填报！', offset: 200, type: 'error' });
        //   return;
        // }
        const validateNum = (num) => {
          let reg = /^([0]|([1-9][0-9]*)|(([0]\.\d{1,}|[1-9][0-9]*\.\d{1,})))$/
          if (!reg.test(num)) { return `应大于0！`; }
          reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
          if (!reg.test(num)) {
            return `应保留2位小数！`;
          }
          return false;
        }
        let msg = validateNum(privatePrice);
        if(msg){
          this.$message({ message: `阳光平台采购价${msg}`, offset: 200, type: 'error' });
          return;
        }
        msg = validateNum(declarePrice);
        if(msg){
          this.$message({ message: `集中议价报价${msg}`, offset: 200, type: 'error' });
          return;
        }
        if(Number(privatePrice) <= Number(declarePrice)){
          this.$message({ message: `集中议价报价须低于阳光平台采购价！`, offset: 200, type: 'error' });
          return;
        }
        this.submitButtonLoading = true;
        this.$api.memberApi.submitReoffer({ id: id, userId: userId, privatePrice: privatePrice, declarePrice: declarePrice, status: 7 }).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.$message({ message: '保存成功！', offset: 200, type: 'success' });
              this.getProductPage();
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      getRowKeys(row) {
        return row.id
      },
      handlePagination(pageNo, pageSize, obj){
        if(this[obj] && typeof this[obj] !== 'function'){
          if(pageNo){
            this[obj].pageNo = pageNo;
          }
          if(pageSize){
            this[obj].pageSize = pageSize;
          }
          this[this[obj].fn] && this[this[obj].fn]();
        }
      },
      getDeclareResult: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.getDeclareResult(param).then(res => {
            this.submitButtonLoading = false;
            if(200 === res.status){
              if(200 === res.data.code){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      getProductPage: function(){
        this.submitButtonLoading = true;
        let{ status, pageNo, pageSize } = this.bargainform
        this.productPage({ status, pageNo, pageSize }).then(res => {
          this.handleProductPage(res)
        })
      },
      productPage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.productDeclarePage(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleProductPage: function(res){
        this.bargainform.data = [];
        JSON.parse(res.data.data).forEach((d, index, arr) => {
          d.disabled = 'true';
          if(4 === d.status){
            d.statusName = '已失效'
            d.offerPrice = ''
          }else{
            d.statusName = 8 === d.status ? '已中选' : '可报价'
            d.offerPrice = 8 === d.status ? '' : d.winPrice
            d.winPrice = 8 === d.status ? d.winPrice : ''
          }
          if(d.confirmOn){
            d.offerDate = d.confirmOn.time
          }
          if(0 == d.declarePrice){
            d.declarePrice = null;
          }
          if(0 == d.privatePrice){
            d.privatePrice = null;
          }
          d.id = d.declareId
          // d.fn = (null != d.discount && '' != d.discount) ? 'editRow' : 'saveRow'
          // d.operate = (null != d.discount && '' != d.discount) ? '修改' : '保存'
          d.edit = (null != d.discount && '' != d.discount) ? true : false
          this.bargainform.data.push(d);
        });
        this.bargainform.total = res.data.count;
        this.productOfferList = [...JSON.parse(res.data.data)];
        //console.log(this.productOfferList)
      },
      handleDeclareResult: function(res, type){
        if('DECLARE' === type){
          let array = JSON.parse(res.data.data);
          if(0 < array.length){
            this.declareResult = array[0];
            this.fileListOfferFile = [];
            if(!!array[0].attachsPath && !!array[0].attachsName){
              this.offerform.attachsName = array[0].attachsName;
              this.offerform.attachsPath = array[0].attachsPath;
              this.offerform.disabled = true;
              this.fileListOfferFile.push({ name: array[0].attachsName, url: array[0].attachsPath, response: {data: array[0].attachsPath}});
            }
          }
        }else if('OFFER' === type){
          let d = JSON.parse(res.data.data);
            if(0 < d.length){
              if(+new Date() > d[0].effectiveDate.time && +new Date() < d[0].expiryDate.time){
                this.btnActive[4] = true;
                this.offerform.disabled = false;
                // if(this.offerform.disabled){
                //   this.btnActive[4] = true;
                // }
              }else{
                this.btnActive[4] = false;
                this.offerform.disabled = true;
              }
            }
        }
      },
      getBargainOnlinePage: function(){
        let { stype, pageNo, pageSize } = { ...this.bargainOnlineForm }
        this.bargainOnlineList({ stype, pageNo, pageSize }).then(res => {
          this.handleBargainOnlineList(res.data)
        })
      },
      bargainOnlineList: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.listDeclareResult(param).then(res => {
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleBargainOnlineList: function(res){
        this.bargainOnlineForm.data = []
        JSON.parse(res.data).forEach((w, index) => {
          const d = { id: w.id, producerName: w.companyName, goodsNum: w.goodsNum, offerDate: this.toDateString(w.createOn.time, 'yyyy-MM-dd HH:mm'), attachsName: w.attachsName }
          if(w.uploadOn && w.uploadOn.time >= w.createOn.time){
            d.uploadDate = this.toDateString(w.uploadOn.time, 'yyyy-MM-dd HH:mm')
          }
          d.statusName = '未上传'
          d.operate = '上传附件'
          d.fn = 'pdfAttachsUpload'
          if(w.attachsPath){
            d.attachsPath = w.attachsPath
            d.statusName = '已上传'
          }
          this.bargainOnlineForm.data.push(d)
        })
        this.bargainOnlineForm.total = res.data.count
      },
      getBusinessConfig: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.getBusinessConfig(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleBusinessConfigList: function(res){
        this.configList = [...JSON.parse(res.data.data)]
        this.configList.forEach((w, index) => {
          let {stype, skey, scode, flag } = { ...w };
          let key = [stype, skey, scode].join('').toLocaleLowerCase()
          if('XN' === stype){
            if(null == this.xnConfigMap.get(key)){
              this.xnConfigMap.set(key, [])
            }
            this.xnConfigMap.get(key).push(w);
            //必选项 设置
            if(flag){
              this.requiredMap.set(key, flag);
            }
          }else if('ZN' === stype){
            // if(null == this.znConfigMap.get(key)){
            //   this.znConfigMap.set(key, [])
            // }
            // this.znConfigMap.get(key).push(w);
          }
        })
      },
      getProductOfferPage: function(){
        this.submitButtonLoading = true;
        let { status, pageNo, pageSize } = this.queryform;
        this.productOfferPage({ status, pageNo, pageSize }).then(res => {
          this.handleProductOfferPage(res)
        })
      },
      productOfferPage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.productPage(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleProductOfferPage: function(res){
        this.queryform.data = [];
        // const data = typeof res.data.data || res.data;
        JSON.parse(res.data.data).forEach((d, index, arr)=>{
          if(this.btnActive[4]){
            if(d.confirmed){
              d.fn = 'getByAssess';
              if(!d.operator || 0 == d.operator){
                d.btnType = 'success';
                d.operate = '填报';
              }else{
                d.btnType = 'primary';
                d.operate = '修改';
              }
            }
          }
          if(d.score){
            d.score = ((Number(d.score) / 2 * 100)>>0) / 100
          }
          if(!d.operator || 0 == d.operator){
            d.score = '';
          }
          this.queryform.data.push(d);
        });
        this.queryform.total = res.data.count;
      },
      getByAssess(d){
        //let param = { productId: this.product.productId, operator: this.operator, status: 3 };
        let param = { productId: this.product.productId, operator: this.operator, status: 0 };
        if(d){
          param.productId = d.id;
          param.operator = 0;
        }
        this.submitButtonLoading = true;
        this.$api.memberApi.getByAssess(param).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              if(response.data.data){
                this.goAssess(JSON.parse(response.data.data));
                this.sumQualityScore();
              }
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'info' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      goAssess(d){
        this.submitButtonLoading = false;
        this.product.drugInfo = `联盟药品质量综合评价：` + [d.drugName, d.drugDosage, d.packageSpecific, d.code].join('-');
        this.product.productId = d.id;
        this.product.code = d.code;
        this.blackInputVisible = false;
        this.product.blackMark = false;

        this.activeName = ['xn11', 'xn12', 'xn13', 'xn14', 'xn15', 'xn16', 'xn17', 'xn18', 'xn19'];
        this.product.remark = d.remark;
        this.product.stype = d.drugCode;
        this.product.score = 0;
        this.dialogFormVisible = true;
        this.selectedMap.clear();
        const isNew = 0 === d['configIds'].length;
        this.configList.forEach((o, index) => {
          let subKey = (`${o.stype}${o.skey}${o.scode}`).toLowerCase();
          let val = this.product[subKey];
          let exists = -1 < d['configIds'].indexOf(o['id'])
          if('object' === typeof val){
            if(isNew){
              this.product[subKey] = [];
            }else{
              if(exists){
                let score = this.selectedMap.get(subKey) || 0;
                score += Number(o['svalue'])
                this.product[subKey].push(o['id']);
                this.selectedMap.set(subKey, score)
              }else{
                let idx = val.indexOf(o['id']);
                if(-1 < idx){
                  this.product[subKey].splice(idx, 1);
                }
              }
            }
          }else{
            if(isNew){
              if(o['flag']){
                this.product[subKey] = o['id'];
                this.selectedMap.set(subKey, Number(o['svalue']))
              }
            }else{
              if(exists){
                this.product[subKey] = o['id'];
                this.selectedMap.set(subKey, Number(o['svalue']))
              }else{
                if(!this.selectedMap.has(subKey)){
                  this.product[subKey] = '';
                }
              }
            }
          }
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid){
            const { code, stype, score, productId, blackMark, blackRecord, remark } = { ...this.product };
            if(11 > score || 200 < score){
              this.$message.error(`药品综合评价分应介于11-100之间！`);
              return;
            }
            let d = this[formName];
            if(d.blackMark && !d.blackRecord){
              this.$message.error(`请说明澄清不良记录！`);
              return;
            }
            let idList = [];
            for(let key of this.selectedMap.keys()){
              let val = this.product[key];
              // console.log(`selected: key & val =>`, key, val)
              if(val){
                if(`number` === typeof val){
                  idList.push(val);
                }else if(`object` === typeof val && 0 < val.length){
                  idList = idList.concat(val);
                }
              }
            }
            //联盟综合评价总分＝（药品维度指标得分+企业维度指标得分）÷ 2
            //计算DRS得分 规则：1	≥95	五星	60 2	≥90	四星半	58 3	≥85	四星	56 4	≥80	三星半	54 5	≥75	三星	52 6	≥70	二星半	47 7	≥65	二星	42 8	≥60	一星半	36 9	＜60	一星	30
            let value = score / 2;
            let drs = 30;
            let statusDesc = '一星';
            if(value >= 95){
              drs = 60;
              statusDesc = '五星';
            }else if(value >= 90){
              drs = 58;
              statusDesc = '四星半';
            }else if(value >= 85){
              drs = 56;
              statusDesc = '四星';
            }else if(value >= 80){
              drs = 54;
              statusDesc = '三星半';
            }else if(value >= 75){
              drs = 52;
              statusDesc = '三星';
            }else if(value >= 70){
              drs = 47;
              statusDesc = '二星半';
            }else if(value >= 65){
              drs = 42;
              statusDesc = '二星';
            }else if(value >= 60){
              drs = 36;
              statusDesc = '一星半';
            }

            let objson = {};
            Object.assign(objson, { code, stype, score, drs, statusDesc, productId, blackMark, blackRecord, remark });
            objson.ids = idList;

            this.submitButtonLoading = true;
            this.$api.memberApi.submitAssess(objson).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  this.$message({ message: '药品综合评价填报已完成，请关闭本页面，并选择其他您要填报的药品！', offset: 200, type: 'success' });
                }else{
                  this.$message({ message: response.data.data, offset: 200, type: 'error' });
                }
              }else{
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
          } else {
            this.submitButtonLoading = false;
          }
        });
      },
      closeDialogForm(){
        this.dialogFormVisible = false;
        this.getProductOfferPage();
      },
      clearValidate(formName){
        this.$refs[formName].clearValidate();
      },
      beforeRemove(file, fileList) {
        console.log(file);
        if(file.status !== 'ready')
          return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handleRemoveOfferFile(file, fileList) {
        this.offerform.attachsName = '';
        this.offerform.attachsPath = '';
        this.fileListOfferFile = fileList.slice(0,0);
      },
      handleSuccessOfferAttachs(response, file, fileList) {
        if (response.code === 200) {
          this.bargainStep1.attachsName = file.name;
          this.bargainStep1.attachsPath = response.data;
          this.offerAttachs = fileList;
        } else {
          this.$message.error(response.msg);
          this.offerAttachs = fileList.slice(0,0);
        }
      },
      handleRemoveOfferAttachs(file, fileList) {
        this.bargainStep1.attachsName = '';
        this.bargainStep1.attachsPath = '';
        this.offerAttachs = fileList.slice(0,0);
      },
      beforeOfferFileUpload(file) {
        const supportFileType = ["data"];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message({ message: '上传的报价文件格式错误（文件格式应为：' + supportFileType + '）', offset: 200, type: 'error' });
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      handleRemovefddbrsqzsImg(file, fileList) {
        this.form.attachsName = '';
        this.form.attachsPath = '';
        this.fileListfddbrsqzsImg = fileList.slice(0,0);
      },
      handleSuccessfddbrsqzsImg(response, file, fileList) {
        if (response.code === 200) {
          this.form.attachsName = file.name;
          this.form.attachsPath = response.data;
          this.fileListfddbrsqzsImg = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListfddbrsqzsImg = fileList.slice(0,0);
        }
      },
      handleSuccessOfferFile(response, file, fileList) {
        if (response.code === 200) {
          this.offerform.attachsName = file.name;
          this.offerform.attachsPath = response.data;
          this.fileListOfferFile = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListOfferFile = fileList.slice(0,0);
        }
      },
      handleError(response, file, fileList) {
        this.$message.error(`上传失败，请稍后再试`);
      },
      handlePreview(file) {
        console.log("handlePreview",file);
        let fileUrl = process.env.VUE_APP_BASE_URL + '/member/readflie.jspx?filePath=' + file.response.data;
        //let fileUrl = process.env.VUE_APP_BASE_URL + file.response.data;
        if (!fileUrl.endsWith('.pdf')) {
          this.dialogImageUrl = fileUrl;
          this.dialogImageVisible = true;
        } else {
          this.dialogPdfUrl = fileUrl;
          // this.dialogPdfUrl = pdf.createLoadingTask(fileUrl);
          // this.dialogPdfVisible = true;
          window.open(fileUrl);
        }
      },
      handleExceed(files, fileList) {
        this.$message.error(`当前限制上传 1 个文件`);
      },
      beforeFileUpload(file) {
        const supportFileType = ["pdf"];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message.error('只能上传['+supportFileType+']格式的文件!');
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      beforeOfferFileUpload(file) {
        const supportFileType = ["data"];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message({ message: '上传的报价文件格式错误（文件格式应为：' + supportFileType + '）', offset: 200, type: 'error' });
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      goLogin(msg) {
        this.$message({ message: '登录过期，请重新登录账户！', offset: 200, type: 'error' });
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 1500)
      }
    }
  }
</script>
<style scoped>
  /deep/ .el-dialog__footer {
    text-align: center;
  }
  .el-dialog .el-form-item{
    margin-bottom: 0px
  }
  .el-dialog .el-tag.el-tag--plain {
    width: 100%;
    display: inline-block;
    white-space: normal;
    text-align: right;
    border: 0px solid #fff;
  }
  /deep/ .el-dialog .el-form-item__label{
    white-space: pre-line !important; /*换行显示*/
    font-size: 12px;
    font-weight: 500;
    line-height: auto;
    text-align: right;
    word-break: break-word;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }

  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }
  .sub-assess-score {
    margin-right: 0px;
    top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Member/MyDeclare.vue